import type { DetailFact } from "#shared/schemas/entityDetail.ts";
import { formatDate, formatDateTime, formatDuration } from "@web/lib/format.ts";

/**
 * The server sends raw values plus a kind; display formatting stays on the client
 * so an export can reuse exactly what the panel shows.
 */
export function formatFact(fact: DetailFact): string {
  const { value, kind } = fact;
  if (value === null || value === "") return "—";

  switch (kind) {
    case "duration":
      return typeof value === "number" ? formatDuration(value) : String(value);
    case "date":
      return formatDate(String(value));
    case "datetime":
      return formatDateTime(String(value));
    case "bool":
      return value ? "Yes" : "No";
    case "ratio":
      return typeof value === "number" ? `${Math.round(value * 100)}%` : String(value);
    case "number":
      return typeof value === "number" ? value.toLocaleString() : String(value);
    case "text":
    case "url":
      return String(value);
  }
}

/** Facts with nothing in them are dropped rather than rendered as a row of dashes. */
export function presentFacts(facts: readonly DetailFact[]): DetailFact[] {
  return facts.filter((f) => f.value !== null && f.value !== "");
}
